import { Injectable } from '@angular/core';
import { AuthenticationService } from '@bo-client/core/authentication/authentication.service';
import { Router } from '@angular/router';
import { path } from '@bo-client/shared/constants/path';

@Injectable()
export class TmPreventLoggedInAccessGuard {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate() {
    let isLogged = false;
    if (this.authenticationService) {
      isLogged = this.authenticationService.isAuthenticated();
    }
    if (isLogged) {
      this.router.navigate([path.tmPrefix + '/' + path.tmDesktop]);
      return true;
    } else {
      this.router.navigate([path.tmPrefix + '/' + path.tmHome]);
      return false;
    }
  }
}
